import { useEffect } from 'react';
import { useViewportSizeUpdaterEffect } from '../hooks/useViewportSizeUpdaterEffect';
import { TimeService } from '../services/time/TimeService';
export function GlobalEffects() {
    useViewportSizeUpdaterEffect();
    useEffect(() => {
        const timeService = TimeService.getNotificationInterface();
        timeService.notifyStart();
        return () => {
            timeService.notifyStop();
        };
    }, []);
    return null;
}
